import { useLDClient } from 'launchdarkly-react-client-sdk';
export var launchdarklyIdentify = function (id) {
    var ldClient = useLDClient();
    if (ldClient) {
        ldClient.identify({
            key: id,
            custom: process.env.LD_CYPRESS ? { cypress: true } : {},
        });
    }
};
